export default "__VITE_ASSET__CVMRWOPp__"